/**
 * 🎵 Dragonious shared audio — Golden Apex soundtrack.
 *
 * Central place for the pack-open / egg-hatch reveal soundtrack so both
 * subsystems share the same URL + mute preference key. Owner drop
 * Feb 9, 2026.
 */
export const GOLDEN_APEX_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_omni-brand-1/artifacts/0tmsrh0k_golden_apex.mp4";

/** Single mute preference for every Dragonious reveal (CCG + Egg Nest). */
export const DRAGONIOUS_MUTE_KEY = "ccg_pack_music_muted";
